import { render, staticRenderFns } from "./levelByLevel.vue?vue&type=template&id=4a888caa&"
import script from "./levelByLevel.vue?vue&type=script&lang=ts&"
export * from "./levelByLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports